module.exports = __webpack_public_path__ + "img/43.553b368f.jpg";